import React, { memo, useContext } from 'react';
import firebase from '../firebase/firebase';
import Avatar from '@material-ui/core/Avatar';
import { AuthContext } from '../context/auth.context';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles(({ spacing, palette, breakpoints }) => ({
	popover: {
		padding: spacing(2.1, 1),
		display: 'flex',
		backgroundColor: palette.grey[900],
		width: '90vw',
		maxWidth: spacing(42),
		[breakpoints.up('sm')]: {
			padding: spacing(2)
		}
	},
	popoverContent: {
		padding: spacing(0, 1),
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		flex: 1,
		[breakpoints.up('sm')]: {
			padding: spacing(0, 1.5)
		}
	},
	popoverAvatar: {
		margin: spacing(0, 1),
		width: spacing(12),
		height: spacing(12)
	},
	signOutButton: {
		marginTop: spacing(2)
	},
	bolder: {
		fontWeight: 500
	},
	name: {
		color: '#fff',
		fontSize: '0.825rem',
		lineHeight: 1.66,
		[breakpoints.up('sm')]: {
			fontSize: '0.875rem'
		}
	},
	email: {
		color: '#fff',
		fontSize: '0.75rem',
		[breakpoints.up('sm')]: {
			fontSize: '0.70rem'
		}
	}
}));

function ProfilePopover({ anchorEl, setAnchorEl }) {
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;
	const classes = useStyles();
	const currentUser = useContext(AuthContext);
	const up600 = useMediaQuery('(min-width:600px)');

	return (
		<Popover
			id={id}
			open={open}
			anchorEl={anchorEl}
			onClose={() => setAnchorEl(null)}
			anchorOrigin={{
				vertical: up600 ? 'bottom' : 'top',
				horizontal: up600 ? 'center' : 'left'
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: up600 ? 'center' : 'left'
			}}>
			<div className={classes.popover}>
				<Avatar
					alt={currentUser.displayName}
					src={currentUser.photoURL}
					className={classes.popoverAvatar}
				/>
				<div className={classes.popoverContent}>
					<Typography variant="body2" className={classes.name}>
						Signed in as{' '}
						<span className={classes.bolder}>{currentUser.displayName}</span>
					</Typography>
					<Typography variant="caption" className={classes.email}>
						{currentUser.email}
					</Typography>

					<Button
						variant="contained"
						color="primary"
						size="small"
						className={classes.signOutButton}
						onClick={() => firebase.auth().signOut()}>
						Sign Out
					</Button>
				</div>
			</div>
		</Popover>
	);
}

export default memo(ProfilePopover);
